<template>
	<div class="container mt-3">
		<div class="gap-2 d-flex mb-3">
			<router-link :to="{name: 'lists'}" class="btn btn-lg btn-outline-secondary flex-grow-1">Список</router-link>
			<router-link :to="{name: 'groups'}" class="btn btn-lg btn-outline-secondary flex-grow-1">Группы</router-link>
		</div>
		
		<div v-if="selGroup.id">
			<div class="card mb-3">
				<div class="card-header bg-white d-flex justify-content-between align-items-center pe-2">
					<div class="fs-5 fw-bold">{{selGroup.name}}</div>
					<div class="d-flex gap-1">
						<div class="btn btn-sm btn-primary" @click="onGroupEdit()">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
							</svg>
						</div>
						<div class="btn btn-sm btn-danger" @click="onGroupDelete()">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
							</svg>
						</div>
					</div>
				</div>
				<div class="card-body p-2">
					<div class="progress" style="height: 10px;">
						<div 
							:style="{width: getPercent(selGroup.items.filter(el => el.checked).length, selGroup.items.length)+'%'}" 
							class="progress-bar" 
							:class="selGroup.items.filter(el => el.checked).length != selGroup.items.length ? '' : 'bg-success'">
						</div>
					</div>
				</div>
				<div class="list-group list-group-flush">
					<div v-for="element in sortedElems" :key="element.id" class="list-group-item pe-2">
						<div class="d-flex justify-content-between align-items-center">
							<div class="form-check flex-grow-1 d-flex align-items-center">
								<input 
									type="checkbox" 
									class="form-check-input" 
									:id="'element-' + element.id"
									v-model="element.checked" 
									@change="onChangeChecked()"
									style="width: 30px; height: 30px; margin-right: 15px;" />
								<label class="form-check-label text-break w-100" :for="'element-' + element.id" 
									:class="element.checked ? 'text-decoration-line-through' : ''">
									{{element.name}}
								</label>
							</div>
							<div class="d-flex gap-1">
								<div class="btn btn-sm btn-primary" @click="onElementEdit(element)">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
									</svg>
								</div>
								<div class="btn btn-sm btn-danger" @click="onElementDelete(element.id)">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
									</svg>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="d-grid mb-3">
				<div class="btn btn-lg btn-primary" @click="doElementAdd()">Добавить элемент</div>
			</div>
		</div>
		<div v-else>
			<div class="card">
				<div class="card-body text-center">
					ГРУППА НЕ НАЙДЕНА
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import lib from '@/lib';

export default {
	name: "Group",
	mixins: lib.mixins,
	computed: {
		selGroup(){
			return this.appModel.groups.find(group => group.id == this.$route.params.id) || {id: null, name: '', items: []};
		},
		sortedElems(){
			return this.selGroup.items.sort(this.dynamicSort([
				{
					field: 'checked',
					order: 'asc',
				},
				{
					field: 'name',
					order: 'asc',
				}
			]));
		},
	},
	methods: {
		getPercent: lib.getPercent,
		
		dynamicSort(fields){
			return (a, b) => {
				for (let { field, order } of fields){
					if (a[field] !== b[field]){
						if(typeof(a[field]) === 'string'){
							return (order === 'asc' ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field]));
						} else {
							return (order === 'asc' ? a[field] - b[field] : b[field] - a[field]);
						}
					}
				}
				return 0;  // Если поля идентичны, объекты считаются равнозначными
			};
		},
		
		onChangeChecked(){
			this.appModel.doElementCheckedToggle();
		},
		
		doElementAdd(){
			let data = {
				name: prompt('Название элемента'),
				count: '',
			};
			if(data.name){
				let ret = this.appModel.doElementAdd(this.$route.params.id, data);
				if(ret.success){
					
				} else {
					alert(ret.error);
				}
			}
		},
		onElementEdit(element){
			let data = {
				name: prompt('Название элемента', element.name),
			};
			if(data.name){
				let ret = this.appModel.doElementEdit(this.$route.params.id, element.id, data);
				if(ret.success){
					
				} else {
					alert(ret.error);
				}
			}
		},
		onElementDelete(id){
			if(confirm('Вы уверены?')){
				let ret = this.appModel.doElementDelete(this.$route.params.id, id);
				if(ret.success){
					
				} else {
					alert(ret.error);
				}
			}
		},
		onGroupEdit(){
			let data = {
				name: prompt('Название группы', this.selGroup.name),
			};
			if(data.name){
				let ret = this.appModel.doGroupEdit(this.$route.params.id, data);
				if(ret.success){
					
				} else {
					alert(ret.error);
				}
			}
		},
		onGroupDelete(){
			if(confirm('Вы уверены?')){
				let ret = this.appModel.doGroupDelete(this.$route.params.id);
				if(ret.success){
					this.$router.push('/groups');
				} else {
					alert(ret.error);
				}
			}
		},
	},
};
</script>
